export interface FileResponse {
  data: Blob;
  fileName: string;
}

export const handleDownload = (
  promise: Promise<FileResponse>,
  setIsLoading?: (isLoading: boolean) => void,
  setFoutmelding?: () => void
) => {
  if (setIsLoading) {
    setIsLoading(true);
  }

  promise.then(
    (result) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;

      link.setAttribute("download", result.fileName);

      document.body.appendChild(link);

      link.click();

      link.remove();
      if (setIsLoading) {
        setIsLoading(false);
      }
    },
    (_error) => {
      if (setIsLoading) {
        setIsLoading(false);
      }

      if (setFoutmelding) {
        setFoutmelding();
      }
    }
  );
};
